<template>

    <multiselect v-model="DisplayValue" :options="options" :multiple="false" track-by="name" :clear-on-select="false" :placeholder="isUsdt==true? 'Select USDT TRC20' : 'Select Payment Option'" :show-labels="false" label="name" :preselect-first="true">
        <p slot="noResult" class="text-danger"> Oops! No Payment Option found.</p>
    </multiselect>

</template>
<script>
    import Multiselect from "vue-multiselect";
    export default {
        name: "PaymentOptionDropdown",
        props: ["values",'isUsdt'],

        components: {
            Multiselect,

        },
        data: function () {
            return {
                options: [],
                value: '',
                render: 0
            }
        },
        methods: {
            getData: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                debugger;
                this.$https.get('/Contact/PaymentOptionList?isDropDown=true', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                    
                    if (response.data != null) {
                        response.data.results.forEach(function (cat) {
                            if (root.isUsdt == true) {
                                if (cat.name == 'USDT TRC20') {
                                    root.options.push({
                                        id: cat.id,
                                        name: cat.name
                                    })
                                }                                
                            }
                            else {
                                if (cat.name != 'USDT TRC20') {
                                    root.options.push({
                                        id: cat.id,
                                        name: cat.name
                                    })
                                }
                            }
                            
                        })
                    }
                }).then(function () {
                    root.value = root.options.find(function (x) {
                        return x.id == root.values;
                    })
                });
            },
        },
        computed: {
            DisplayValue: {
                get: function () {
                    if (this.value != "" || this.value != undefined) {
                        return this.value;
                    }
                    return this.values;
                },
                set: function (value) {
                    this.value = value;
                    this.$emit('input', value.id);
                }
            }
        },
        mounted: function () {
            this.getData();
        },
    }
</script>